import React from 'react'
import cx from 'classnames'
import styles from './ActionToggle.sass'
import { SwitchCheckbox } from 'components/SwitchCheckbox'

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  label: string
  description: string
  value: boolean
  onChange(e: unknown): void
  isThemed?: boolean
  dataTest?: string
  disabled?: boolean
}

export const ActionToggle = ({
  label,
  description,
  value,
  onChange,
  className,
  isThemed,
  dataTest,
  disabled,
  ...rest
}: Props) => {
  return (
    <div className={cx(styles.container, className)} {...rest}>
      <div className={styles.information}>
        <div className={styles.label}>{label}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <SwitchCheckbox
        noText
        value={value}
        onChange={onChange}
        success={isThemed}
        disabled={disabled}
        data-test={dataTest}
      />
    </div>
  )
}
